/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Artifacts_Trash_MovedInputs */



/**
* | output |
* | --- |
* | "App moved to the trash. You can restore it for {days} days." |
*
* @param {Artifacts_Trash_MovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_trash_moved = /** @type {((inputs: Artifacts_Trash_MovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Trash_MovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`App in den Papierkorb verschoben. Sie lässt sich ${i?.days} Tage lang wiederherstellen.`)
	return /** @type {LocalizedString} */ (`App moved to the trash. You can restore it for ${i?.days} days.`)
});